import { Button, Spin } from "antd";
import { useApiUrl, useCustomMutation, useInvalidate, useNotification } from "@refinedev/core";
import React from "react";

export const DeleteFiles = () => {
  const [loading, setLoading] = React.useState(false);

  const apiUrl = useApiUrl();
  const { open, close } = useNotification();
  const { mutate } = useCustomMutation();
  const invalidate = useInvalidate();

  const triggerDeletion = () => {
    setLoading(true);
    mutate(
      {
        url: `${apiUrl}/nav-warnings/bulk/delete`,
        method: "post",
        values: {},
      },
      {
        onError: (error, variables, context) => {
          setLoading(false);
          open?.({
            type: "error",
            message: "Error",
            description: `Error: ${error.message}`,
          });
          close?.("error-notification-key");
        },
        onSuccess: (data, variables, context) => {
          setLoading(false);
          invalidate({
            resource: "nav-warnings",
            invalidates: ["list"],
          });
          open?.({
            type: "success",
            message: "bulk delete",
            description: "Successfully deleted all files",
          });
          close?.("success-notification-key");
        },
      }
    );
  };

  return loading ? (
    <Spin></Spin>
  ) : (
    <div>
      <Button
        type="default"
        size="middle"
        onClick={triggerDeletion}
        target="_blank"
        danger
        // icon={<Icons.DeleteOutlined />}
      >
        Bulk Delete
      </Button>
    </div>
  );
};
